import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper-details-data" }
const _hoisted_2 = { class: "text-raleway-22 t-blue mb-1 mr-3 title-section company-details" }
const _hoisted_3 = { class: "wrapper-details company-detail" }

import PersonalDataComponent from "./personalData/personalDataComponent.vue";
import AvatartComponent from "../avatar/avatarComponent.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'companyDetailsComponent',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$tc("company_details")), 1),
    _createElementVNode("article", _hoisted_3, [
      _createVNode(PersonalDataComponent),
      _createVNode(AvatartComponent)
    ])
  ]))
}
}

})